import * as React from "react";
import {
    Grid,
    Button,
    Typography,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent
} from "components/controls/widget";
import { Checkbox } from "components/controls/formControls";
import { SavePhase, useApplication } from "../store";
import { MemberView } from "./member";
import { LegalRepresentativeView } from "./legalRepresentative";
import { PhoneVerificationCodeDialog } from "../../member-validation/phoneVerificationCodeDialog";
import { useMemberValidation } from "../../member-validation/store";
import { formInputProps } from "./definition";

const Submits = () => {
    let [state, actions] = useApplication();
    const disable = state.savePhase !== SavePhase.None;
    return <Grid item>
        <Grid container direction="row" spacing={8}>
            <Grid item>
                <Button variant="contained" color="primary" disabled={disable} onClick={() => actions.save()}>{'Uložit rozpracovanou přihlášku'}</Button>
            </Grid>
            <Grid item>
                <Button variant="contained" color="success" disabled={disable} onClick={() => actions.setStateField("savePhase", SavePhase.SubmitConfirmation)}>{'Dokončit a odeslat ke zpracování'}</Button>
            </Grid>
        </Grid>

    </Grid>;
}



const SaveOrSubmitDialog = () => {
    let [state, { sendEmail, emailReceived, backToForm }] = useApplication();
    let { entity, loading, updating, previousMemberEmail, savePhase } = state;

    const completed = savePhase === SavePhase.Submitted;
    const emailChanged = previousMemberEmail !== entity.member.email;
    const disable = loading || updating;

    const title = completed ? 'Přihláška byla odeslána ke zpracování' : 'Přihláška byla uložena';
    const content1 = emailChanged
        ? `Přihlášku jsme uložili a na email ${entity.member.email} jsme odeslali odkaz pro pozdější úpravu přihlášky. Prosíme, zkontrolujte poštovní schránku. Pokud zpráva bezprostředně nedorazí, zkontrolujte email. Pokud v něm uvidíte překlep, vraťte se zpět do formuláře, email opravte a uložte přihlášku znovu.`
        : 'Přihlášku jsme uložili, odkaz pro pozdější úpravu zůstává stejný.';
    const content2 = 'Pokud si přejete email s odkazem pro úpravu poslat znovu, stiskněte tlačítko “Poslat email pro úpravu”.'
    const textBtn1 = completed ? 'Potvrzuji přijetí emailu a odesílám přihlášku ke zpracování' : 'Potvrzuji přijetí emailu';
    const textBtn2 = emailChanged ? 'Zpět do formuláře' : 'OK';
    return <Dialog open={true} scroll="paper" >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
            <Typography variant="body1">{content1}</Typography>
            <Typography variant="body1">{content2}</Typography>
        </DialogContent>
        <DialogActions>

            {emailChanged && <Button color="success" variant="contained" onClick={emailReceived} disabled={disable}>{textBtn1}</Button>}
            <Button color="primary" variant="contained" onClick={backToForm} disabled={disable}>{textBtn2}</Button>
            <Button variant="contained" onClick={sendEmail} disabled={disable}>{'Poslat email pro úpravu'}</Button>

        </DialogActions>
    </Dialog>;
}

const SubmitConfirmationDialog = () => {
    let [, { backToForm, accept }] = useApplication();

    return <Dialog open={true} scroll="paper" >
        <DialogTitle>{'Dokončit přihlášku a odeslat ke zpracování'}</DialogTitle>
        <DialogContent>
            <Typography variant="h6">{'Přejete si přihlášku skutečně odeslat ke zpracování? Přihlášku budete moci prohlížet a stornovat, avšak úpravy již nebudou možné.'}</Typography>
        </DialogContent>
        <DialogActions>
            <Button color="primary" variant="contained" onClick={accept}>{'Odeslat'}</Button>
            <Button variant="contained" onClick={backToForm}>{'Zpět do formuláře'}</Button>
        </DialogActions>
    </Dialog>;
}

interface Props {
    editedByClub: boolean,
}

const View = ({ editedByClub }: Props) => {
    let [state, actions] = useApplication();
    const [{ showPhoneVerificationCodeDialog }] = useMemberValidation();
    const savePhase = state.savePhase;
    const showSaveOrSubmitDialog = !editedByClub && (savePhase === SavePhase.Saved || savePhase === SavePhase.Submitted);
    const showSubmitConfirmationDialog = savePhase === SavePhase.SubmitConfirmation;

    React.useEffect(() => {
        if (savePhase === SavePhase.Saved && editedByClub) {
            actions.backToForm();
        }
    }, [state.savePhase]);


    return <Grid container direction="column" spacing={32}>
        <Grid item>
            <MemberView editedByClub={editedByClub} />
        </Grid>

        <Grid item>
            <LegalRepresentativeView />
        </Grid>

        <Grid item>
        </Grid>

        <Grid item>
            <Checkbox {...formInputProps('statutesAgreement', state, actions)} />
            <Checkbox {...formInputProps('verificationAgreement', state, actions)} />
        </Grid>

        <Submits />

        {showSaveOrSubmitDialog && <SaveOrSubmitDialog />}
        {showSubmitConfirmationDialog && <SubmitConfirmationDialog />}
        {showPhoneVerificationCodeDialog && <PhoneVerificationCodeDialog memberIdt={state.entity.id} />}
    </Grid>;
}

export {
    View as ApplicationForm
}






